<template>
  <div v-if="products.list.length" class="demon-wrap">
    <demon-strat
      ref="demonStrat"
      :uuid="uuid"
      :prop-cur-year="curYear"
      :prop-start-year="startYear"
      :prop-products="products"
      :profit="profit"
      :profit-type="profitType"
      :insured-age="insuredAge"
      :add-and-take="addAndTake"
      :account-data="profitProduct.accountData"
      :insurance-key="accountInsKey"
      :account-btns-text="accountBtnsText"
      @update-year="updateYear"
      @product-change="handlePrdChange"
      @part-change="handlePartChange"
      @type-change="handleTypeChange"
      @rate-change="handleRateChange"
      @bonus-change="handleBonusChange"
    >
      <template slot="header">
        <h3 class="demonstration-title after-bd-b">
          保单利益演示
          <div v-if="!isForPresentation" class="profit-type-btn">
            <a
              class="btn after-bdr"
              href="javascript:;"
              data-stat-id="lbt"
              :class="{ cur: profitType === 0 }"
              @click="handleChangeDataType(0)"
            >
              列表图
            </a>
            <a
              class="btn after-bdr"
              href="javascript:;"
              data-stat-id="qxt"
              :class="{ cur: profitType === 1 }"
              @click="handleChangeDataType(1)"
            >
              曲线图
            </a>
          </div>
        </h3>
      </template>
      <template v-if="true" slot="body">
        <!-- 趋势图 -->
        <trend-chart
          v-if="profit && profitType"
          ref="trendChart"
          :profit="profit"
          :insured-age="insuredAge"
          :start-year="startYear"
          :cur-year="curYear"
          @update-year="updateYear"
        />
      </template>
      <template v-if="!isForPresentation" slot="footer">
        <div class="demon-table-btn">
          <a
            v-if="profit.length"
            class="btn after-bdr"
            href="javascript:;"
            data-stat-id="cklyysb"
            @click="handleTbOpen"
          >利益表格</a>
          <a
            v-if="profitProduct && profitProduct.hasAccountRateFlag"
            class="btn after-bdr"
            href="javascript:;"
            data-stat-id="wnll"
            @click="handleUnivOpen"
          >万能利率</a>
          <a
            v-if="accountInsKey && !isForPresentation && !isPublic"
            class="btn after-bdr"
            href="javascript:;"
            data-stat-id="jgy_zjlq"
            @click="isAddTakeReduceBaofhow = true"
          >追加领取</a>
        </div>
        <!-- irr -->
        <irr-calculator
          v-if="isIrrShow"
          v-show="profitProduct && profitProduct.irrFlag"
          :uuid="uuid"
          :insured-age="insuredAge"
          :start-year="startYear"
          :profit-product="profitProduct"
        />
        <div v-if="displayExpSum" class="explicit-summary">
          <div class="inner">
            <p v-for="(item, index) in expSum" :key="index">
              {{ item.name }}：{{ item.detail }}
            </p>
          </div>
        </div>
      </template>
    </demon-strat>

    <!-- 利益表 -->
    <demon-tb
      v-model="isTbShow"
      :profit="profit"
      :main-ins="mainIns"
      :product-data="products"
      :insured-age="insuredAge"
      :start-year="startYear"
      :active-nav-left="activeNavLeft"
      :account-btns-text="accountBtnsText"
      @tb-product-change="handlePrdChange"
      @tb-rate-change="handleRateChange"
      @tb-bonus-change="handleBonusChange"
      @part-change="handlePartChange"
    />

    <!-- 结算 -->
    <bxs-bottom-sheets
      v-model="isUnivShow"
      class="universal-sheets"
      height="middle"
      :title="univIns.name ? `${univIns.name}利率` : ''"
      prevent-scroll-through
    >
      <div ref="BScroll" class="universal-wrap">
        <div class="universal-table">
          <div class="row">
            <div class="column">
              结算年月
            </div>
            <div class="column">
              结算利率
            </div>
          </div>
          <div v-for="(item, index) in univList" :key="index" class="row">
            <div class="col">
              {{ item.settlementCycle | parseTime }}
            </div>
            <div class="col">
              {{ item.rate }}
            </div>
          </div>
        </div>
      </div>
    </bxs-bottom-sheets>

    <!-- 追加领取  -->
    <add-take-reduce-baof
      v-if="isAddTakeReduceBaofhow"
      class="account_add_and_take"
      :uuid="uuid"
      :insured-age="insuredAge"
      :product-key="products.value"
      :insurance-key="accountInsKey"
      :raw-all-add-and-take-data="profitProduct"
      @open-or-close-popup="handleCloseAddTakeReduce"
      @update="updateAccount"
    />
  </div>
</template>

<script>
import qs from 'qs'
import DemonStrat from './src/demonstrat'
import AddTakeReduceBaof from './addTake/addTakeReduceBaof'
import IrrCalculator from './src/irrCalculator'
import DemonTb from './src/demonTb'
import TrendChart from './src/trendChart'
import { getUrlParam, parseTime } from 'common/js/common'
import {
  initInterest,
  getInterest,
  getInterestDetail,
  getAccountRateList,
  initPublicInterest,
  getPublicInterest
} from 'api/index'
import { BottomSheets } from 'bxs-ui-vue'
import BScroll from 'better-scroll'

const DEFAULT_INDEX = 0

export default {
  name: 'Dem',
  components: {
    DemonStrat,
    DemonTb,
    TrendChart,
    IrrCalculator,
    AddTakeReduceBaof,
    [BottomSheets.name]: BottomSheets
  },
  filters: {
    parseTime (value) {
      return parseTime(value, '{y}-{m}')
    }
  },
  props: {
    isPublic: Boolean,
    isForPresentation: Boolean,
    isFamily: Boolean,
    isIrrShow: {
      type: Boolean,
      default: true
    },
    propCurYear: Number,
    propInsuredAge: {
      type: Number,
      default: 0
    },
    propUuid: String,
    curInsurances: [Array, Object]
  },
  data () {
    const { propUuid, propCurYear, propInsuredAge } = this
    return {
      uuid: propUuid || getUrlParam('uuid'),
      products: {
        list: [],
        value: '',
        type: 0,
        part: 0
      },
      activeNavLeft: 0,
      profit: [],
      curYear: propCurYear,
      insuredAge: propInsuredAge,
      show: false,
      isUnivShow: false,
      univList: [],
      isAddTakeReduceBaofhow: false,
      addAndTake: null,
      isTbShow: false,
      profitType: 0
    }
  },
  computed: {
    expSum () {
      const { profit } = this
      if (!profit || !Array.isArray(profit)) return
      return profit.filter(item => {
        return item.detail
      })
    },
    displayExpSum () {
      const { expSum } = this
      return expSum && expSum.length
    },
    // 当前产品利率信息
    profitProduct () {
      const { products } = this
      if (!Array.isArray(products.list) || !products.value) return
      return products.list.filter(item => {
        return item.productId === products.value
      })[0]
    },
    // 当前计划书
    insurances () {
      const { curInsurances, uuid } = this
      let ins
      if (Array.isArray(curInsurances)) {
        const thisIns = curInsurances.filter(item => {
          return item.resultUuid === uuid
        })[0]
        ins = thisIns && thisIns.resultData
      } else {
        ins = curInsurances.resultData
      }
      return ins
    },
    // 当前产品主险
    mainIns () {
      const {
        insurances,
        products: { value }
      } = this
      if (
        !insurances ||
        !insurances.productGroupList[0] ||
        !Array.isArray(insurances.productGroupList[0].prodOrderList)
      ) {
        return
      }
      const prod = insurances.productGroupList[0].prodOrderList.find(
        item => item.key === value
      )
      if (!prod) return
      // 首个 key !== 'common' 的险种 => 主险
      let ins = prod.mulInsOrderList[0]
      if (ins.key === 'common') {
        ins = prod.mulInsOrderList[1] || {}
      }
      return ins
    },
    // 当前产品追加领取险种id
    accountInsKey () {
      const {
        insurances,
        products: { value }
      } = this
      if (
        !insurances ||
        !insurances.productGroupList[0] ||
        !Array.isArray(insurances.productGroupList[0].prodOrderList)
      ) {
        return
      }
      const prod = insurances.productGroupList[0].prodOrderList.find(
        item => item.key === value
      )
      if (!prod) return
      const ins = prod.mulInsOrderList.find(
        item => item.account && item.accountData && item.accountData.accountPart
      )
      return ins && ins.key
    },
    // 当前产品中的万能险（唯一）
    univIns () {
      const { insurances, products } = this
      let empty = {}
      if (!insurances || !Array.isArray(insurances.productGroupList)) {
        return empty
      }
      const prodOrderList = insurances.productGroupList[0].prodOrderList
      if (!Array.isArray(prodOrderList)) return empty
      const prodOrder = prodOrderList.filter(prod => {
        return prod.key === products.value
      })[0]
      if (!prodOrder || !Array.isArray(prodOrder.mulInsOrderList)) return empty
      const mulInsOrderList = prodOrder.mulInsOrderList
      return mulInsOrderList.filter(item => item.account)[0] || empty
    },
    // 追加领取｜减保领取tab类型
    productPart () {
      const {
        products: { part }
      } = this
      return part === 0 ? 'oneList' : 'twoList'
    },
    // 追加领取切换按钮
    accountBtnsText () {
      const { addAndTake, accountInsKey, profitProduct } = this
      const accountPart =
        profitProduct.accountData && profitProduct.accountData.accountPart
      let btns = []
      const twoList = profitProduct.multiData && profitProduct.multiData.twoList
      if ((!addAndTake && !accountInsKey) || !twoList) return btns
      switch (accountPart) {
        case 'add':
          btns = ['追加保费前', '追加保费后']
          break
        case 'take':
          btns = ['领取保费前', '领取保费后']
          break
        case 'addAndTake':
          btns = ['追加/领取前', '追加/领取后']
          break
        default:
      }
      // 减保领取
      if (!btns.length) {
        btns = ['减保领取前', '减保领取后']
      }
      return btns
    }
  },
  watch: {
    propUuid (newId) {
      this.uuid = newId
      this.fetchData()
    },
    isUnivShow (value) {
      if (!value) return
      this.$nextTick(() => {
        this.bsInit()
      })
    }
  },
  created () {
    this.profitCache = {}
    this.fetchData()
    appBridge.hideLoading()
  },
  methods: {
    bsInit () {
      this.scroller = new BScroll(this.$refs.BScroll, {
        preventDefault: false,
        probeType: 3,
        scrollX: true, // 启动x轴滚动
        scrollY: true, // 启动y轴滚动
        momentum: false, // 是否开启快速滑动
        directionLockThreshold: 0, // 斜滑时，锁定一个方向滚动
        bounce: {
          // 滑动到边缘时出现回弹动画
          top: false,
          bottom: false
        }
      })
      function columnScroll () {
        const frozenColumn = document.querySelectorAll(
          '.universal-table .column'
        )
        frozenColumn.forEach(el => {
          el.style.transform = `translate3d(0px, ${-this.y}px, 0px)`
        })
      }
      this.scroller.on('scroll', columnScroll)
      this.scroller.on('scrollEnd', columnScroll)
      this.scroller.on('beforeScrollStart', () => {
        setTimeout(() => {
          this.scroller.refresh()
        }, 20)
      })
    },
    fetchData (uuid = this.uuid) {
      if (!uuid) return
      const initFetch = this.isPublic ? initPublicInterest : initInterest
      initFetch({
        uuid: uuid
      })
        .then(({ data: { data, success } } = { data: {} }) => {
          if (!success) {
            this.$emit('set-interest-key', [])
            return
          }
          data = this.filterProfit(data)
          if (data[DEFAULT_INDEX]) {
            let { isFamily, products, propCurYear, productPart } = this
            const defaultPrd = data[DEFAULT_INDEX]
            // 家庭计划书初始化用 twoList
            // 若无数据则 oneList
            const defaultPrdData =
              (isFamily
                ? defaultPrd.multiData.twoList
                : defaultPrd.multiData[productPart]) ||
              defaultPrd.multiData.oneList
            if (!defaultPrd.multiData.twoList && products.part) {
              this.products.part = 0
            }
            // 默认演示年龄
            if (!propCurYear && defaultPrd.showYear != 0) {
              const _curYear =
                defaultPrd.showYear -
                1 -
                this.insuredAge -
                defaultPrd.startIndex
              if (
                _curYear >= 0 &&
                _curYear <= this.getMaxLen(defaultPrdData) - 1
              ) {
                this.curYear = _curYear
              }
            }
            data.forEach(item => {
              if (!item.productName) {
                // 未配置取产品名
                item.productName = this.findProductName(uuid, item.productId)
              }
              // 缓存初始化数据
              this.storageProfit(item, true)
            })
            this.startYear = products.startIndex = defaultPrd.startIndex
            products.startPolicyNo = defaultPrd.startPolicyNo
            this.profit = defaultPrdData
            this.products.value = defaultPrd.productId
            this.products.list = data
            this.addAndTake = defaultPrd.addAndTakeData
          }
          this.$emit('set-interest-key', this.getInterestKey(data))
        })
        .catch(() => {
          this.$emit('set-interest-key', [])
        })
    },
    // 获取
    fetchProfit (product = {}) {
      const { productId, uuid, bonus, rate, extraTitle } = product
      const {
        isPublic,
        isFamily,
        productPart,
        profitCache,
        insurances,
        products: { type }
      } = this
      let parameter = {
        bonus: {},
        rate: {},
        uuid,
        productId
      }
      bonus && (parameter.bonus.value = bonus.value)
      rate && (parameter.rate.value = rate.value)
      extraTitle && extraTitle.length && (parameter.extraIndex = type)
      const profitKey = this.getProfitKey(bonus, rate, extraTitle)
      const fetch = isPublic ? getPublicInterest : getInterestDetail
      if (isPublic && insurances.publicPbUuid) {
        parameter.publicPbUuid = insurances.publicPbUuid
      }

      if (
        profitCache[uuid] &&
        profitCache[uuid][productId] &&
        profitCache[uuid][productId][profitKey]
      ) {
        this.profit = profitCache[uuid][productId][profitKey]
        this.curYear = Math.min(this.getMaxLen(this.profit) - 1, this.curYear)
      } else {
        fetch(
          qs.stringify({
            jd: JSON.stringify(parameter)
          })
        ).then(({ data, info, success } = {}) => {
          if (success) {
            // 未追加领取时 twoList = null
            this.profit = isFamily
              ? data['twoList'] || data['oneList']
              : data[productPart]
            this.curYear = Math.min(
              this.getMaxLen(this.profit) - 1,
              this.curYear
            )
            parameter.multiData = data
            this.storageProfit({
              extraTitle,
              ...parameter
            })
          }
        })
      }
    },
    // 过滤
    filterProfit (data) {
      const { productPart } = this
      let result = []

      // 过滤无数据
      if (Array.isArray(data)) {
        result = data.filter(item => {
          return (
            item.data.length ||
            (item.multiData &&
              ((item.multiData.twoList && item.multiData.twoList.length) ||
                (item.multiData.oneList && item.multiData.oneList.length)))
          )
        })
      }

      // 过滤自定义利率分红
      result.forEach(pd => {
        if (
          pd.bonus &&
          Array.isArray(pd.bonus.opts) &&
          pd.bonus.opts.length > 1
        ) {
          let tempMap = {}
          pd.bonus.opts = pd.bonus.opts.filter(option => {
            if (tempMap[option.value]) {
              return false
            } else {
              tempMap[option.value] = true
              return true
            }
          })
        }

        if (pd.rate && Array.isArray(pd.rate.opts) && pd.rate.opts.length > 1) {
          let tempMap = {}
          pd.rate.opts = pd.rate.opts.filter(option => {
            if (tempMap[option.value]) {
              return false
            } else {
              tempMap[option.value] = true
              return true
            }
          })
        }
      })
      return result
    },
    // 缓存
    storageProfit (
      { uuid, productId, multiData, bonus, rate, extraTitle } = {},
      isClear
    ) {
      const data = this.isFamily
        ? multiData['twoList'] || multiData['oneList']
        : multiData[this.productPart] || []
      const profitKey = this.getProfitKey(bonus, rate, extraTitle)
      if (!this.profitCache[uuid]) {
        this.profitCache[uuid] = {
          [productId]: {}
        }
      }
      // 追加领取修改后，缓存数据标记为初始化（isClear = true）
      // 若在追加前（productPart = 0）的状态缓存新数据时，
      // 追加后的缓存可清空，需要请求新的数据
      if (this.profitCache[uuid][productId] && !isClear) {
        this.profitCache[uuid][productId][profitKey] = data
      } else {
        this.profitCache[uuid][productId] = {
          [profitKey]: data
        }
      }
    },
    // 缓存's key
    getProfitKey (bonus, rate, extraTitle) {
      let profitKey
      let tempBonusKey
      let tempRateKey
      const {
        products: { type, part }
      } = this

      if (bonus) {
        if (bonus.value || bonus.value === 0) {
          tempBonusKey = `bonus_${bonus.value}`
        } else {
          console.warn('bonus缺少默认值')
        }
      }
      if (rate) {
        if (rate.value || rate.value === 0) {
          tempRateKey = `rate_${rate.value}`
        } else {
          console.warn('rate缺少默认值')
        }
      }

      if (tempBonusKey && tempRateKey) {
        profitKey = `${tempBonusKey}-${tempRateKey}`
      } else {
        profitKey = tempBonusKey || tempRateKey || 'key'
      }
      profitKey = `${part}-${profitKey}`
      if (extraTitle && extraTitle.length) {
        profitKey = `${type}-${profitKey}`
      }

      return profitKey
    },
    getInterestKey (data) {
      let keys = []
      data.forEach(pd => {
        if (!Array.isArray(pd.data)) return
        pd.data.forEach(({ key }) => {
          if (keys.indexOf(key) < 0) keys.push(key)
        })
      })
      return keys
    },
    // 最长的数据
    getMaxLen (profit) {
      let ary = profit.map(item => {
        return item.values.length
      })
      return Math.max(...ary)
    },
    // 设置年龄
    updateYear (val) {
      this.$emit('update-year', val)
      this.curYear = val
    },
    findProductName (uuid, key) {
      const { curInsurances } = this
      let ins, products
      if (Array.isArray(curInsurances)) {
        ins = curInsurances.filter(item => {
          return item.resultUuid === uuid
        })[0]
        if (!ins || !Array.isArray(ins.productData)) return ''
        products = ins.productData.filter(item => {
          return item.productId === key
        })
        return products[0] && products[0].productName
          ? products[0].productName
          : ''
      } else {
        ins = curInsurances.resultData
        if (
          !ins ||
          !Array.isArray(ins.productGroupList) ||
          !ins.productGroupList[0] ||
          !Array.isArray(ins.productGroupList[0].prodOrderList)
        ) {
          return ''
        }
        products = ins.productGroupList[0].prodOrderList.filter(item => {
          return item.key === key
        })
        return products[0] && products[0].titleName ? products[0].titleName : ''
      }
    },
    updateAccount (data) {
      this.fetchData()
      this.$emit('update-account-map', data)
    },
    handleChangeDataType (value) {
      this.profitType = value
      if (!this.$refs.trendChart || value) return
      const year = this.$refs.trendChart.getCurYear()
      year >= 0 && this.updateYear(year)
    },
    // 打开表
    handleTbOpen () {
      let dnavigation = document.querySelector(
        '.demonstration-container .navigation'
      )
      if (dnavigation) {
        this.activeNavLeft = dnavigation.scrollLeft
      }
      this.isTbShow = true
    },
    // 打开万能险利率
    handleUnivOpen () {
      const {
        uuid,
        profitProduct: { productId }
      } = this
      getAccountRateList({ uuid, productId }).then(
        ({ data: { data, success } } = { data: {} }) => {
          if (!success || !data) return
          this.univList = data
          this.isUnivShow = true
        }
      )
    },
    // 切换产品
    handlePrdChange (index) {
      const { list } = this.products
      const curProduct = list[index]
      this.products.part = DEFAULT_INDEX
      this.products.value = curProduct.productId
      this.products.startIndex = curProduct.startIndex
      this.addAndTake = curProduct.addAndTakeData
      this.fetchProfit(curProduct)
    },
    // 切换追加领取
    handlePartChange (index) {
      const {
        products: { list, value }
      } = this
      const curProduct = list.find(item => {
        return item.productId === value
      })
      this.products.part = index
      this.fetchProfit(curProduct)
    },
    // 切换类型
    handleTypeChange (index) {
      const {
        products: { list, value }
      } = this
      const curProduct = list.find(item => {
        return item.productId === value
      })
      this.products.type = index
      this.fetchProfit(curProduct)
    },
    // 切换利率
    handleRateChange (val, index) {
      const { list } = this.products
      const curProduct = list[index]
      if (curProduct && curProduct.rate) {
        this.products.list[index].rate.value = val
        this.fetchProfit(curProduct)
      }
    },
    // 切换分红
    handleBonusChange (val, index) {
      let { list } = this.products
      let curProduct = list[index]
      if (curProduct && curProduct.bonus) {
        this.products.list[index].bonus.value = val
        this.fetchProfit(curProduct)
      }
    },
    handleCloseAddTakeReduce () {
      this.isAddTakeReduceBaofhow = false
    }
  }
}
</script>

<style lang="postcss">
@import 'variable';

.demonstration-title {
  position: relative;
  .profit-type-btn {
    position: absolute;
    right: 0.09rem;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    font-size: 0.24rem;
    font-weight: normal;
    > a {
      flex: 1;
      color: #333;
      padding: 0.04rem 0.21rem;
      margin: 0 0.01rem;
      &::after {
        border-color: #fff;
        border-radius: 10rem;
      }
    }
  }
}

.demon-table-btn {
  display: flex;
  padding-bottom: 0.36rem;
  padding-left: 0.21rem;
  padding-right: 0.21rem;
  font-size: 0.3rem;
  text-align: center;
  .btn {
    flex: 1;
    padding: 0.14rem 0;
    margin: 0 0.09rem;
    &:after {
      border-radius: 0.24rem;
    }
    &:before {
      @apply --extend-click;
    }
  }
}

.navigation-wrap {
  width: 100%;
  padding-right: 0.9rem;
}

.navigation {
  overflow-x: scroll;
  overflow-y: hidden;
  width: 100%;
  height: 0.9rem;
  margin-bottom: -1px;
  background: var(--white-color);
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
    background-color: transparent;
  }
  .nav {
    height: 0.9rem;
    line-height: 0.9rem;
    text-align: center;
    font-size: 0;
    padding: 0 0.3rem;
    .item {
      position: relative;
      width: 33.3%;
      height: 100%;
      padding: 0 0.1rem;
      display: inline-block;
      font-size: 0.3rem;
      background-color: var(--white-color);
      color: var(--nine-color);
      outline: none;
      vertical-align: middle;
      @apply --text-ellipsis;
      &:before {
        z-index: 2;
        content: '';
        position: absolute;
        bottom: 1px;
        opacity: 0;
        left: 31%;
        width: 18%;
        height: 0.08rem;
        border-radius: 10rem;
      }
    }
    .cur:before {
      opacity: 1;
    }
  }
}

.profit-condition {
  display: flex;
  margin: 0 auto 0.5rem;
  padding: 0 0.28rem;
  &.bonus-wrap {
    padding: 0 0.26rem;
  }
  .profit-item {
    flex: 1;
    display: block;
    position: relative;
    margin-right: 0.06rem;
    -webkit-tap-highlight-color: transparent;
    &:first-child {
      .profit-label:after {
        border-top-left-radius: 0.24rem;
        border-bottom-left-radius: 0.24rem;
      }
      input {
        &:checked + label {
          border-top-left-radius: 0.12rem;
          border-bottom-left-radius: 0.12rem;
        }
      }
    }
    &:last-child {
      margin-right: 0;
      .profit-label:after {
        width: 197%;
        border-top-right-radius: 0.24rem;
        border-bottom-right-radius: 0.24rem;
      }
      input {
        &:checked + label {
          border-top-right-radius: 0.12rem;
          border-bottom-right-radius: 0.12rem;
        }
      }
    }
    .profit-label {
      display: block;
      padding: 0.12rem;
      text-align: center;
      font-size: 0.24rem;
      p {
        line-height: 0.26rem;
        @apply --text-ellipsis;
      }
    }
    input[type='radio'] {
      z-index: 1;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      appearance: none;
      vertical-align: middle;
      background: transparent;
      border: none;
    }
  }
}
.bonus-wrap {
  padding: 0.4rem 0.28rem;
  font-size: 0.3rem;
  .select {
    display: inline-block;
    position: relative;
    -webkit-tap-highlight-color: transparent;
  }
  .bonus {
    padding: 0 0.6rem 0 0.3rem;
    font-size: 0.3rem;
    line-height: 1;
    appearance: none;
    border: none;
    background-color: transparent;
    color: var(--diff-color);
  }

  .icon-arrow_down {
    position: absolute;
    right: 0.2rem;
    top: 50%;
    transform: translateY(-50%);
    font-size: 0.24rem;
    line-height: 1;
    margin-top: -1px;
    color: var(--diff-color) !important;
  }
  .profit-item {
    .profit-label-in {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      min-height: 0.52rem;
      line-height: 0.26rem;
    }
  }
}

.slide-pop {
  .close {
    color: #999;
  }
}

.explicit-summary {
  overflow: hidden;
  .inner {
    margin-bottom: 0.3rem;
    padding: 0.18rem 0.28rem;
    font-size: 0.26rem;
    line-height: 1.46;
    color: #333;
    background-color: #f8f8f8;
  }
  p {
    margin-bottom: 0.18rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.universal-sheets {
  .bx-sheets-scroll {
    height: 100%;
    padding: 0.4rem 0.3rem;
  }
}

.universal-wrap {
  overflow: hidden;
  height: 100%;
}

.universal-table {
  width: 100%;
  border-left: 1px solid #e5e5e5;
  font-size: 0.26rem;
  color: #666;
  .row {
    display: flex;
    border-bottom: 1px solid #e5e5e5;
    text-align: center;
    &:first-child {
      border-bottom: none;
    }
  }
  .col,
  .column {
    flex: 1;
    border-right: 1px solid #e5e5e5;
    line-height: 0.6rem;
  }
  .column {
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
    background-color: #f8f8f8;
  }
}
</style>
